module.exports = __webpack_public_path__ + "img/new-empty-state.46ae19a6.png";